module.exports = __webpack_public_path__ + "static/media/24-vscode.389f119b.svg";